import Alpine from "alpinejs";
import collapse from "@alpinejs/collapse";

import "./search";
import "./model-gallery";
import "./presets-filter";
import "./brands-listing";
import "./color-select";

window.Alpine = Alpine;
Alpine.plugin(collapse);
Alpine.start();
